module.exports = __webpack_public_path__ + "static/media/29.25ca4908.jpg";